import { UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

export interface IValuationReadyProps {
  isDesktop: boolean;
  onClick(): void;
}

export const ValuationReady: React.FC<IValuationReadyProps> = ({ isDesktop, onClick }) => {
  return (
    <div className={cn(styles['container'], isDesktop ? styles['container_desktop'] : styles['container_mobile'])}>
      <UIText2>Кажется, вы уже оценивали эту квартиру.</UIText2>
      <div className={styles['link-wrapper']}>
        <div className={styles['link']} onClick={onClick}>
          Перейти к оценке
        </div>
      </div>
    </div>
  );
};

ValuationReady.displayName = 'ValuationReady';
